import {
  GET_TASK_DASHBOARD_STATS,
  GET_TASK_DASHBOARD_STATS_SUCCESS,
  GET_TASK_DASHBOARD_STATS_ERROR,
} from './actionTypes';

const initialState = {
  errorGetTaskDashboardStats: '',
  loadingGetTaskDashboardStats: false,
  stats: null,
};

const getTaskDashboardStats = (state = initialState, action) => {
  switch (action.type) {
    case GET_TASK_DASHBOARD_STATS:
      state = { ...state, loadingGetTaskDashboardStats: true };
      break;
    case GET_TASK_DASHBOARD_STATS_SUCCESS:
      state = { ...state, loadingGetTaskDashboardStats: false, stats: action.payload.stats };
      break;
    case GET_TASK_DASHBOARD_STATS_ERROR:
      state = { ...state, errorGetTaskDashboardStats: action.payload, loadingGetTaskDashboardStats: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getTaskDashboardStats;
